import {AlertButton} from "@ionic/vue";
import Translator from "@/plugins/Translator";
import {AlertRoles} from "@/models/AlertButtons/AlertRoles";

const translator = Translator.getInstance();
const i18n = translator.getI18nGlobalInstance();

/**
 * UI Button um eine Aktion abzubrechen
 */
export const ConfirmButton: AlertButton = {
    role: AlertRoles.CONFIRM,
    text: i18n.t("actions.confirm"),
};
